
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const PaymentCanceledPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow px-4 py-16 bg-luxury-50">
        <div className="container mx-auto max-w-3xl">
          <div className="bg-white rounded-xl shadow-luxury p-8 text-center">
            <h1 className="text-2xl font-bold mb-4">Payment Canceled</h1>
            <p className="text-gray-600 mb-6">
              Your payment was canceled. If you have any questions or need assistance,
              feel free to contact our support team.
            </p>
            
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/services">
                <Button variant="outline" className="w-full">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Back to Services
                </Button>
              </Link>
              <Link to="/">
                <Button className="bg-gold hover:bg-gold/90 text-white w-full">
                  Return to Home
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentCanceledPage;
